import { describeResource } from '@siteless/resource';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { database } from '../../config/firebase';
import { thisOscarsYear } from '../../config/constants';

const BallotsStartedResource = describeResource('BallotsStartedResource', {
  get: async () => {
    const value: Record<string, boolean> = {};

    (
      await getDocs(
        query(
          collection(database, 'users'),
          where(`ballotData.${thisOscarsYear}.isStarted`, '==', true)
        )
      )
    ).forEach((document) => {
      value[document.id] = true;
    });

    return value;
  },
});

export default BallotsStartedResource;
